<template>
    <v-menu 
        :nudge-right="20"
        :nudge-bottom="20"
        transition="scale-transition"
        min-width="300px"
        max-width="200px"
        :disabled="readonly"
    >
        <template v-slot:activator="{on}">
            <v-text-field 
                :value="getValue"
                :label="label"
                prepend-icon="event" 
                readonly 
                outlined
                :clearable="!readonly"
                @click:clear="updateValue(null)"
                v-on="on"
                :rules="rules"
            > 
            </v-text-field>
        </template>
        <v-date-picker 
            locale="id" 
            :type="type" 
            no-title 
            @input="updateValue($event)"
            :readonly="readonly"
        >
        </v-date-picker>
    </v-menu>
</template>


<script>

export default {
    props: {
        type: {
            type: [ String ],
            default: "date"
        },

        label: {
            type: String,
            default: ""
        },

        dateValue: {
            type: [ Date, String],
            default: null
        },

        readonly: {
            type: Boolean,
            default: false
        },

        rules: {
            type: Array,
            required: false
        }
    },

    computed: {
        getValue() {
            return this.dateValue ? this.dateValue : "";
        }
    },

    methods: {
        updateValue(newValue) {
            this.$emit('changed', newValue);
        }
    }
}

</script>